// Extra context that components use to make queries.
// The Sweep and Group pages put a filter in mergeFilters that limits
// all queries down to that particular sweep our group.
import React, {useContext} from 'react';

import {type Filter} from '../../util/filterTypes';
import {type Key} from '../../util/runTypes';

export interface RunsQueryContext {
  entityName: string;
  projectName: string;
  internalProjectId: string | undefined;
  mergeFilters?: Filter<Key>;
  runSetName?: string;
  report?: {
    id: string;
    parentID?: string;
  };
  sweep?: {
    id: string;
    earlyTerminate: boolean;
  };
}

type UninitializedRunsQueryContext = Partial<RunsQueryContext>;

/**
 * TODO: this is a perf trap. Please do not add to this context anymore.
 * Consider moving to an alternative solution to avoid cascading re-renders.
 */
export const RunQueryContext =
  React.createContext<UninitializedRunsQueryContext>({});

export const useHasReportRuns = () => {
  const {report} = useContext(RunQueryContext);
  return report != null;
};
